<template>
  <el-dialog class="annotation-dialog" :style="{ '--el-dialog-padding-primary': 0 }" append-to-body :show-close="false" :close-on-click-modal="false" v-model="visible" width="50%">
    <template #header>
      <div class="annotation-title">
        <span>帮助</span>
        <i class="iconfont icon-guanbi" @click="visible = false"></i>
      </div>
    </template>
    <div class="annotation-body">
      <div v-html="config.formData" class="annotation-body-context" />
      <div class="annotation-body-btn">
        <el-button type="primary" @click="visible = false">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  // 组件名称
  name: 'annotationTips',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      visible: false,
      config: {}
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    open(config) {
      this.config = config
      this.visible = true
    },
  },
}
</script> 

<style scoped lang="scss">
.annotation-body {
  min-height: 170px;
  display: flex;
  flex-direction: column;
  &-context {
    flex: 1;
    max-height: 600px;
    overflow: auto;
  }
  &-btn {
    text-align: right;
  }
}

.annotation-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px #e5e5e5;
  .icon-guanbi {
    cursor: pointer;
    &:hover {
      color: #4e86ff;
    }
  }
}
</style>

<style lang="scss">
.annotation-dialog {
  .el-dialog__header {
    padding: 0 20px;
    box-sizing: border-box;
    height: 50px;
  }
  .el-dialog__body {
    padding: 20px;
  }
}
</style>
